import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditService from "../../../../services/screens/admin/oralbook/EditUnitService";
import { ActionTypes } from "../../../actionTypes/screens/admin/oralbook/EditUnitActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";
import _ from "lodash";

import * as Helper from "../../../../utils/Helper";
import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.oralbook.editunit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (id, sectionId, index) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id, sectionId, index });

            EditService.loadScreenView(
                id,
                sectionId,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response, index));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data, index) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
        index
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveUnitAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_UNIT_ASYNC, vo });

            EditService.saveUnit(
                vo,
                response => {
                    dispatch(Actions.saveUnitSuccess(response));
                },
                error => {
                    dispatch(Actions.saveUnitFailure(error));
                }
            );
        };
    },

    saveUnitSuccess: data => ({
        type: ActionTypes.SAVE_UNIT_SUCCESS,
        parentType: ActionTypes.SAVE_UNIT_ASYNC,
        data
    }),

    saveUnitFailure: error => ({
        type: ActionTypes.SAVE_UNIT_FAILURE,
        parentType: ActionTypes.SAVE_UNIT_ASYNC,
        error
    }),

};

//
// Initial State
//
const INITIAL_STATE = {
    unit: {
        data: {}
    },
    courseName: "", 
    sectionName: "", 
    order: null,
    resourceId: ""
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data, index }) => {
    let { unit, unitCount, ...others } = data;
    unit.unitType = "POKA1";
    if (unit.data) 
        unit = { ...unit, data: JSON.parse(unit.data).singleUnits[0] };
    return { ...state, unit, order: (index > 0 ? index : (unitCount + 1)), ...others, resourceId: Helper.generateUUID() };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_UNIT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_UNIT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_UNIT_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
